import { render, staticRenderFns } from "./HomeworksWidget.vue?vue&type=template&id=343b25e0"
import script from "./HomeworksWidget.vue?vue&type=script&lang=js"
export * from "./HomeworksWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343b25e0')) {
      api.createRecord('343b25e0', component.options)
    } else {
      api.reload('343b25e0', component.options)
    }
    module.hot.accept("./HomeworksWidget.vue?vue&type=template&id=343b25e0", function () {
      api.rerender('343b25e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/dashboard_widgets/HomeworksWidget.vue"
export default component.exports